import { ContentBlock } from '@tytapp/content';
import { ContentBlockType } from '@tytapp/content';
import { ContentBlockEditorComponent } from '@tytapp/content/content-block-editor-component';
import { Component, inject } from '@angular/core';
import { ContentBlockViewComponent } from '@tytapp/content/content-block-view-component';
import { ApiHonorRoll, UsersApi } from '@tytapp/api';
import { environment } from '@tytapp/environment';

export interface HonorRollBlock extends ContentBlock {
}

@Component({
    template: `
        <div style="margin: 0px;padding: 0px; background-color: transparent;">
            <div style="margin: 0px auto;padding: 0px;">
                <div style="padding: 0px;">
                <div class="column">
                    <ng-container *ngFor="let entry of entries">
                        {{ entry.first_name }} {{entry.last_name}} <br>
                    </ng-container>
                    <br>
                </div>
                </div>
            </div>
        </div>
    `,
    styles: [`
        .column {
            column-count: 2;
            column-gap: 3em;
            column-rule: 1px solid rgba(255, 255, 255, 0.2);
        }
    `]
})
export class ViewComponent extends ContentBlockViewComponent<HonorRollBlock> {
    private usersApi = inject(UsersApi);

    entries: ApiHonorRoll[];

    async ngOnInit() {
        if (environment.showDevTools)
            this.entries = sampleData();
        else
            this.entries = await this.usersApi.getHonorRoll().toPromise();
    }
}

@Component({
    template: `
        <div>
            Dynamic Honor Roll
        </div>
        <em>(This block is populated with names via TYT Platform's automatic
            Honor Roll system as used in the Amplify campaign)</em>
    `,
    styles: [
        `
        `
    ]
})
export class EditorComponent extends ContentBlockEditorComponent<HonorRollBlock> {
}


export const HONOR_ROLL_BLOCK_TYPE: ContentBlockType<HonorRollBlock> = {
    id: 'honor-roll',
    label: 'Amplify Honor Roll',
    icon: 'emoji_events',
    template: {},
    preview: {},
    previewSettings: {
        horizontalAlign: 'center',
        verticalAlign: 'center'
    },
    editorComponent: EditorComponent,
    viewComponent: ViewComponent
};

function sampleData(): ApiHonorRoll[] {
    return <any>[
        {
            "id": 943,
            "first_name": "Greg",
            "last_name": "Griffin",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-20T14:53:14.304-08:00"
        },
        {
            "id": 944,
            "first_name": "Greg",
            "last_name": "Griffin",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-20T15:04:23.494-08:00"
        },
        {
            "id": 950,
            "first_name": "Aimee ",
            "last_name": "Dion",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-20T15:50:29.118-08:00"
        },
        {
            "id": 951,
            "first_name": "Sean",
            "last_name": "Rodriguez",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-20T15:50:44.604-08:00"
        },
        {
            "id": 952,
            "first_name": "J",
            "last_name": "Y",
            "purchased_quantity": 20,
            "dollar_price": 1000.0,
            "package_name": "The Lead with Jake Tapper",
            "purchased_at": "2018-11-20T15:52:28.735-08:00"
        },
        {
            "id": 953,
            "first_name": "Namisa",
            "last_name": "",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-20T15:52:41.195-08:00"
        },
        {
            "id": 954,
            "first_name": "Michael",
            "last_name": "Khotoveli",
            "purchased_quantity": 10,
            "dollar_price": 500.0,
            "package_name": "Pay What You Can Package ($500)",
            "purchased_at": "2018-11-20T15:53:12.138-08:00"
        },
        {
            "id": 955,
            "first_name": "T",
            "last_name": "E",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-20T15:55:08.784-08:00"
        },
        {
            "id": 956,
            "first_name": "Eric",
            "last_name": "Tedders",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-20T15:55:47.559-08:00"
        },
        {
            "id": 957,
            "first_name": "Jayde",
            "last_name": "Coler",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-20T15:56:08.303-08:00"
        },
        {
            "id": 959,
            "first_name": "Kelly",
            "last_name": "Devers",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-20T16:02:54.676-08:00"
        },
        {
            "id": 960,
            "first_name": "Dylan",
            "last_name": "Thomas",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-20T16:06:51.730-08:00"
        },
        {
            "id": 961,
            "first_name": "John",
            "last_name": "Leaman",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-20T16:09:55.307-08:00"
        },
        {
            "id": 962,
            "first_name": "Shawn",
            "last_name": "Christopher",
            "purchased_quantity": 20,
            "dollar_price": 1000.0,
            "package_name": "CNN Reliable Sources",
            "purchased_at": "2018-11-20T16:14:47.582-08:00"
        },
        {
            "id": 963,
            "first_name": "Marie",
            "last_name": "LaPosta (pronounced LaPASTA)",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-20T16:17:24.859-08:00"
        },
        {
            "id": 968,
            "first_name": "jane",
            "last_name": "kablaoui",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-20T16:20:46.415-08:00"
        },
        {
            "id": 969,
            "first_name": "Tim",
            "last_name": "Oltman",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-20T16:26:08.052-08:00"
        },
        {
            "id": 971,
            "first_name": "Binta",
            "last_name": "Campbell",
            "purchased_quantity": 20,
            "dollar_price": 1000.0,
            "package_name": "PBS NewsHour",
            "purchased_at": "2018-11-20T16:32:35.347-08:00"
        },
        {
            "id": 972,
            "first_name": "Lisa",
            "last_name": "Robbins",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-20T16:34:58.512-08:00"
        },
        {
            "id": 973,
            "first_name": "Vicki",
            "last_name": "C",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-20T16:38:24.459-08:00"
        },
        {
            "id": 975,
            "first_name": "Brian",
            "last_name": "Lopez",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-20T16:53:58.462-08:00"
        },
        {
            "id": 977,
            "first_name": "Dominique",
            "last_name": "Langlois",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-20T17:20:31.404-08:00"
        },
        {
            "id": 978,
            "first_name": "Dominique",
            "last_name": "Langlois",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-20T17:28:55.176-08:00"
        },
        {
            "id": 979,
            "first_name": "Kevin",
            "last_name": "Nelson",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-20T17:30:22.519-08:00"
        },
        {
            "id": 980,
            "first_name": "Brett",
            "last_name": "Boylen",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-20T17:49:36.891-08:00"
        },
        {
            "id": 981,
            "first_name": "Lauren",
            "last_name": "Bandle",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-20T17:49:48.649-08:00"
        },
        {
            "id": 983,
            "first_name": "Trans-girls are magic",
            "last_name": "Jade Hess",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-20T18:01:45.552-08:00"
        },
        {
            "id": 984,
            "first_name": "Will",
            "last_name": "Anderson",
            "purchased_quantity": 10,
            "dollar_price": 500.0,
            "package_name": "Pay What You Can Package ($500)",
            "purchased_at": "2018-11-20T18:01:56.919-08:00"
        },
        {
            "id": 986,
            "first_name": "Sam",
            "last_name": "MukiRi Mburu ",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-20T18:09:45.262-08:00"
        },
        {
            "id": 987,
            "first_name": "Matthew",
            "last_name": "Ross",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-20T18:12:57.391-08:00"
        },
        {
            "id": 988,
            "first_name": "Hiten",
            "last_name": "Dave",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-20T18:24:53.101-08:00"
        },
        {
            "id": 989,
            "first_name": "Mandy",
            "last_name": "Zimmerli",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-20T18:29:22.123-08:00"
        },
        {
            "id": 991,
            "first_name": "Jack",
            "last_name": "Flannery",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-20T18:37:08.053-08:00"
        },
        {
            "id": 993,
            "first_name": "Stephen",
            "last_name": "Toepp",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-20T18:42:09.982-08:00"
        },
        {
            "id": 995,
            "first_name": "Cara",
            "last_name": "Curley",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-20T18:44:28.478-08:00"
        },
        {
            "id": 996,
            "first_name": "Luciane",
            "last_name": "Pacius",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-20T18:50:00.629-08:00"
        },
        {
            "id": 997,
            "first_name": "Broc",
            "last_name": "Nelson",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-20T18:53:46.319-08:00"
        },
        {
            "id": 998,
            "first_name": "Carla and John",
            "last_name": "Cornwall",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-20T19:10:35.119-08:00"
        },
        {
            "id": 999,
            "first_name": null,
            "last_name": null,
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-20T19:10:53.329-08:00"
        },
        {
            "id": 1000,
            "first_name": "Gretchen",
            "last_name": "Miller",
            "purchased_quantity": 10,
            "dollar_price": 500.0,
            "package_name": "Pay What You Can Package ($500)",
            "purchased_at": "2018-11-20T19:15:35.632-08:00"
        },
        {
            "id": 1001,
            "first_name": "Omar",
            "last_name": "Allen",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-20T19:31:18.353-08:00"
        },
        {
            "id": 1002,
            "first_name": "Connor",
            "last_name": "Tweeton",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-20T19:40:16.714-08:00"
        },
        {
            "id": 1003,
            "first_name": "Brian",
            "last_name": "Ephraim",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-20T19:42:36.755-08:00"
        },
        {
            "id": 1004,
            "first_name": "Alex",
            "last_name": "Wortmanp",
            "purchased_quantity": 50,
            "dollar_price": 2500.0,
            "package_name": "Cuomo Prime Time",
            "purchased_at": "2018-11-20T19:43:55.806-08:00"
        },
        {
            "id": 1006,
            "first_name": "Lynne",
            "last_name": "Bajec",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-20T19:46:41.316-08:00"
        },
        {
            "id": 1007,
            "first_name": "Andy",
            "last_name": "Williams",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-20T19:59:40.090-08:00"
        },
        {
            "id": 1008,
            "first_name": "Jackie",
            "last_name": "Collari",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-20T19:59:57.398-08:00"
        },
        {
            "id": 1010,
            "first_name": "Kaj",
            "last_name": "Rankin",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-20T20:21:44.936-08:00"
        },
        {
            "id": 1013,
            "first_name": "Alexander",
            "last_name": "Schmidt",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-21T00:20:11.979-08:00"
        },
        {
            "id": 1017,
            "first_name": "Brian",
            "last_name": "Doogan",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-21T07:19:56.834-08:00"
        },
        {
            "id": 1018,
            "first_name": "Sumus Nimis Vires",
            "last_name": null,
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-21T08:02:15.625-08:00"
        },
        {
            "id": 1020,
            "first_name": "Jimmy",
            "last_name": null,
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-21T08:39:40.748-08:00"
        },
        {
            "id": 1021,
            "first_name": "Chase",
            "last_name": "Miller",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-21T08:41:14.053-08:00"
        },
        {
            "id": 1023,
            "first_name": "Leonard",
            "last_name": "Moore",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-21T10:03:57.798-08:00"
        },
        {
            "id": 1026,
            "first_name": "Bruce",
            "last_name": "Martin",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-21T12:03:40.089-08:00"
        },
        {
            "id": 1027,
            "first_name": "Kristin",
            "last_name": "Germeroth",
            "purchased_quantity": 10,
            "dollar_price": 500.0,
            "package_name": "Pay What You Can Package ($500)",
            "purchased_at": "2018-11-21T12:49:42.910-08:00"
        },
        {
            "id": 1030,
            "first_name": "Meg",
            "last_name": "Perry",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-21T13:21:24.977-08:00"
        },
        {
            "id": 1031,
            "first_name": "Vanessa",
            "last_name": "Abreu",
            "purchased_quantity": 20,
            "dollar_price": 1000.0,
            "package_name": "The Ingraham Angle",
            "purchased_at": "2018-11-21T13:57:26.439-08:00"
        },
        {
            "id": 1032,
            "first_name": "Austin",
            "last_name": "Booth",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-21T14:17:11.852-08:00"
        },
        {
            "id": 1035,
            "first_name": "Kevin",
            "last_name": "Griffin",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-21T15:00:16.299-08:00"
        },
        {
            "id": 1036,
            "first_name": "Dylan",
            "last_name": "Thomas",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-21T15:11:28.202-08:00"
        },
        {
            "id": 1037,
            "first_name": "Lars",
            "last_name": "Nilsson",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-21T15:15:14.348-08:00"
        },
        {
            "id": 1038,
            "first_name": "Robert",
            "last_name": "Cantor",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-21T15:19:12.169-08:00"
        },
        {
            "id": 1039,
            "first_name": "Jarod",
            "last_name": "Settles",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-21T15:49:50.365-08:00"
        },
        {
            "id": 1040,
            "first_name": "Stephen",
            "last_name": "Potvin",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-21T15:56:28.268-08:00"
        },
        {
            "id": 1041,
            "first_name": "Mike and Ashley",
            "last_name": "Bryck",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-21T15:57:10.743-08:00"
        },
        {
            "id": 1045,
            "first_name": "Sonya",
            "last_name": "Sukalski",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-21T19:04:11.055-08:00"
        },
        {
            "id": 1046,
            "first_name": "Hayden",
            "last_name": "Prescott",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-21T21:05:44.708-08:00"
        },
        {
            "id": 1047,
            "first_name": "Milo",
            "last_name": "Wadlin",
            "purchased_quantity": 10,
            "dollar_price": 500.0,
            "package_name": "Pay What You Can Package ($500)",
            "purchased_at": "2018-11-21T21:34:14.009-08:00"
        },
        {
            "id": 1049,
            "first_name": "Cara",
            "last_name": "Curley",
            "purchased_quantity": 10,
            "dollar_price": 500.0,
            "package_name": "Pay What You Can Package ($500)",
            "purchased_at": "2018-11-21T23:33:23.493-08:00"
        },
        {
            "id": 1052,
            "first_name": "Jennifer ",
            "last_name": "Krauter",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-22T09:00:02.270-08:00"
        },
        {
            "id": 1054,
            "first_name": "GREGORY",
            "last_name": "Winston",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-22T09:07:58.782-08:00"
        },
        {
            "id": 1055,
            "first_name": "Emily",
            "last_name": "Ip",
            "purchased_quantity": 50,
            "dollar_price": 2500.0,
            "package_name": "Tucker Carlson Tonight",
            "purchased_at": "2018-11-22T09:18:57.717-08:00"
        },
        {
            "id": 1056,
            "first_name": "Jusjit",
            "last_name": "Lalli",
            "purchased_quantity": 50,
            "dollar_price": 2500.0,
            "package_name": "Anderson 360",
            "purchased_at": "2018-11-22T13:36:09.182-08:00"
        },
        {
            "id": 1066,
            "first_name": "Emiel",
            "last_name": "Rossing",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-23T10:49:38.625-08:00"
        },
        {
            "id": 1068,
            "first_name": "George",
            "last_name": "Grair",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-23T13:51:32.610-08:00"
        },
        {
            "id": 1069,
            "first_name": "Zerin ",
            "last_name": "Firoze",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-23T14:19:45.395-08:00"
        },
        {
            "id": 1070,
            "first_name": "Dick",
            "last_name": "Newell",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-23T14:29:30.212-08:00"
        },
        {
            "id": 1071,
            "first_name": "Daniel",
            "last_name": "Hor",
            "purchased_quantity": 10,
            "dollar_price": 500.0,
            "package_name": "Pay What You Can Package ($500)",
            "purchased_at": "2018-11-23T15:02:24.462-08:00"
        },
        {
            "id": 1073,
            "first_name": "Jacob",
            "last_name": "VanderHaeghen",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-23T15:44:29.753-08:00"
        },
        {
            "id": 1075,
            "first_name": "Nahide",
            "last_name": "Gulensoy",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-23T16:42:15.698-08:00"
        },
        {
            "id": 1078,
            "first_name": "Ken",
            "last_name": "Porter",
            "purchased_quantity": 10,
            "dollar_price": 500.0,
            "package_name": "Pay What You Can Package ($500)",
            "purchased_at": "2018-11-23T19:40:50.082-08:00"
        },
        {
            "id": 1079,
            "first_name": "Jared",
            "last_name": "de Seife",
            "purchased_quantity": 20,
            "dollar_price": 1000.0,
            "package_name": "CBS This Morning",
            "purchased_at": "2018-11-24T00:30:01.916-08:00"
        },
        {
            "id": 1083,
            "first_name": "Susan",
            "last_name": "Hobbs",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-24T18:35:01.084-08:00"
        },
        {
            "id": 1084,
            "first_name": "Kevin",
            "last_name": "Scoggins",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-24T20:24:35.988-08:00"
        },
        {
            "id": 1086,
            "first_name": "Matthew",
            "last_name": "Knell",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-24T23:51:43.519-08:00"
        },
        {
            "id": 1089,
            "first_name": "Gary",
            "last_name": "Breaux",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-25T09:57:55.449-08:00"
        },
        {
            "id": 1093,
            "first_name": "Rachel",
            "last_name": "Smigielski",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-25T12:19:13.610-08:00"
        },
        {
            "id": 1097,
            "first_name": "Mary-Helen",
            "last_name": "Burns",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-25T17:44:01.515-08:00"
        },
        {
            "id": 1098,
            "first_name": "Marie",
            "last_name": "LaPosta (pronounced LaPASTA)",
            "purchased_quantity": 20,
            "dollar_price": 1000.0,
            "package_name": "Pod Save America",
            "purchased_at": "2018-11-25T20:17:47.254-08:00"
        },
        {
            "id": 1099,
            "first_name": "Alex",
            "last_name": "Hanselka",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-25T20:51:23.006-08:00"
        },
        {
            "id": 1100,
            "first_name": "Austin",
            "last_name": "Henderson",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-25T23:59:47.187-08:00"
        },
        {
            "id": 1101,
            "first_name": "Thomas",
            "last_name": "Wenger",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-26T03:10:27.983-08:00"
        },
        {
            "id": 1106,
            "first_name": "Scott",
            "last_name": "Pryor",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-26T10:26:27.417-08:00"
        },
        {
            "id": 1107,
            "first_name": "Jessie",
            "last_name": "Levine",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-26T10:34:31.886-08:00"
        },
        {
            "id": 1108,
            "first_name": "Laura",
            "last_name": "Latimer",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-26T14:05:02.562-08:00"
        },
        {
            "id": 1112,
            "first_name": "Lars",
            "last_name": "Nilsson",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-26T15:48:41.260-08:00"
        },
        {
            "id": 1113,
            "first_name": "Kim",
            "last_name": "Meckley",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-26T15:50:00.421-08:00"
        },
        {
            "id": 1114,
            "first_name": "Lars",
            "last_name": "Nilsson",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-26T15:51:04.319-08:00"
        },
        {
            "id": 1120,
            "first_name": "Annie",
            "last_name": "Nielsen",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-27T03:59:51.809-08:00"
        },
        {
            "id": 1123,
            "first_name": "Elle",
            "last_name": "Welle",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-27T10:52:38.508-08:00"
        },
        {
            "id": 1130,
            "first_name": "Dennis",
            "last_name": "Norrod",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-27T14:56:42.471-08:00"
        },
        {
            "id": 1131,
            "first_name": "Jack",
            "last_name": "Fries",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-27T15:28:51.900-08:00"
        },
        {
            "id": 1133,
            "first_name": "Chris",
            "last_name": "Tomaiolo",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-27T15:56:41.424-08:00"
        },
        {
            "id": 1134,
            "first_name": "Dylan",
            "last_name": "Stark",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-27T16:03:06.099-08:00"
        },
        {
            "id": 1136,
            "first_name": "Kris",
            "last_name": "Martin",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-27T16:07:48.581-08:00"
        },
        {
            "id": 1137,
            "first_name": "Lizzy",
            "last_name": "Carr",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-27T16:11:26.801-08:00"
        },
        {
            "id": 1139,
            "first_name": "",
            "last_name": "Shelton",
            "purchased_quantity": 20,
            "dollar_price": 1000.0,
            "package_name": "Mediaite",
            "purchased_at": "2018-11-27T16:38:44.375-08:00"
        },
        {
            "id": 1140,
            "first_name": "HotKarlMarx",
            "last_name": "",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-27T16:53:44.123-08:00"
        },
        {
            "id": 1141,
            "first_name": "Trans-girls are magic",
            "last_name": "Jade Hess",
            "purchased_quantity": 20,
            "dollar_price": 1000.0,
            "package_name": "Mediaite",
            "purchased_at": "2018-11-27T16:54:08.578-08:00"
        },
        {
            "id": 1142,
            "first_name": "Thomas",
            "last_name": "Kennedy",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-27T17:40:48.185-08:00"
        },
        {
            "id": 1144,
            "first_name": "Caroline",
            "last_name": "Wilson",
            "purchased_quantity": 100,
            "dollar_price": 5000.0,
            "package_name": "US Senate - Bernie Sanders",
            "purchased_at": "2018-11-27T18:41:25.586-08:00"
        },
        {
            "id": 1153,
            "first_name": "Victor",
            "last_name": "Weers",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-28T12:48:51.231-08:00"
        },
        {
            "id": 1155,
            "first_name": "David",
            "last_name": "Schatz",
            "purchased_quantity": 20,
            "dollar_price": 1000.0,
            "package_name": "Hardball with Chris Matthews",
            "purchased_at": "2018-11-28T15:07:07.845-08:00"
        },
        {
            "id": 1156,
            "first_name": "Brian",
            "last_name": "Turner",
            "purchased_quantity": 20,
            "dollar_price": 1000.0,
            "package_name": "Rosario Dawson",
            "purchased_at": "2018-11-28T15:40:31.911-08:00"
        },
        {
            "id": 1159,
            "first_name": "Mr Quimper",
            "last_name": "",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-28T16:22:04.161-08:00"
        },
        {
            "id": 1160,
            "first_name": "Mathew",
            "last_name": "Antonelli",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-28T16:25:54.940-08:00"
        },
        {
            "id": 1161,
            "first_name": "Alphonso",
            "last_name": "",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-28T16:33:07.954-08:00"
        },
        {
            "id": 1162,
            "first_name": "Leslie",
            "last_name": "Guerra",
            "purchased_quantity": 20,
            "dollar_price": 1000.0,
            "package_name": "Willow and Will Smith",
            "purchased_at": "2018-11-28T16:45:44.265-08:00"
        },
        {
            "id": 1163,
            "first_name": "Gerald ",
            "last_name": "Shelton ",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-28T17:39:25.504-08:00"
        },
        {
            "id": 1164,
            "first_name": "Rick",
            "last_name": "Cangelosi",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-28T18:46:01.231-08:00"
        },
        {
            "id": 1165,
            "first_name": "Caroline",
            "last_name": "Parker",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-11-28T18:48:31.903-08:00"
        },
        {
            "id": 1171,
            "first_name": "Sam",
            "last_name": "Katsinis ",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-28T23:43:17.865-08:00"
        },
        {
            "id": 1172,
            "first_name": "Amanda",
            "last_name": "Higham",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-29T01:07:37.291-08:00"
        },
        {
            "id": 1175,
            "first_name": "Jeff",
            "last_name": "Aurand",
            "purchased_quantity": 10,
            "dollar_price": 500.0,
            "package_name": "Pay What You Can Package ($500)",
            "purchased_at": "2018-11-29T06:19:31.551-08:00"
        },
        {
            "id": 1177,
            "first_name": "Shalyn",
            "last_name": "Powell",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-29T07:35:30.236-08:00"
        },
        {
            "id": 1185,
            "first_name": "Nancy",
            "last_name": "Felix-Vega (of Cleveland \u0026amp; Dayton OH)",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-29T13:15:35.132-08:00"
        },
        {
            "id": 1186,
            "first_name": "John",
            "last_name": "Lee",
            "purchased_quantity": 20,
            "dollar_price": 1000.0,
            "package_name": "US Congress - Alexandria Ocasio-Cortez",
            "purchased_at": "2018-11-29T15:47:07.224-08:00"
        },
        {
            "id": 1189,
            "first_name": "Tom",
            "last_name": "Wirts",
            "purchased_quantity": 50,
            "dollar_price": 2500.0,
            "package_name": "The Situation Room with Wolf Blitzer",
            "purchased_at": "2018-11-29T17:27:12.061-08:00"
        },
        {
            "id": 1190,
            "first_name": "Paige ",
            "last_name": "Richardson",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-29T18:10:29.909-08:00"
        },
        {
            "id": 1195,
            "first_name": "Stephanie",
            "last_name": "Manzo",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-30T01:27:51.175-08:00"
        },
        {
            "id": 1199,
            "first_name": "Josh",
            "last_name": "Diekmann",
            "purchased_quantity": 10,
            "dollar_price": 500.0,
            "package_name": "Pay What You Can Package ($500)",
            "purchased_at": "2018-11-30T04:14:30.554-08:00"
        },
        {
            "id": 1200,
            "first_name": "Mariell",
            "last_name": "Thomassen",
            "purchased_quantity": 10,
            "dollar_price": 500.0,
            "package_name": "Pay What You Can Package ($500)",
            "purchased_at": "2018-11-30T04:36:26.319-08:00"
        },
        {
            "id": 1206,
            "first_name": "Jason",
            "last_name": "Constant",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-30T14:59:25.819-08:00"
        },
        {
            "id": 1208,
            "first_name": "Timothy",
            "last_name": "Brennan",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-30T15:28:01.608-08:00"
        },
        {
            "id": 1210,
            "first_name": "Chris",
            "last_name": "Tumey",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-11-30T17:21:14.960-08:00"
        },
        {
            "id": 1217,
            "first_name": "Dustin",
            "last_name": "Laver",
            "purchased_quantity": 20,
            "dollar_price": 1000.0,
            "package_name": "Shailene Woodley",
            "purchased_at": "2018-12-01T11:19:13.634-08:00"
        },
        {
            "id": 1221,
            "first_name": "Katherine",
            "last_name": "Gaeta",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-01T17:41:34.755-08:00"
        },
        {
            "id": 1222,
            "first_name": "Humberto",
            "last_name": "Moreira",
            "purchased_quantity": 10,
            "dollar_price": 500.0,
            "package_name": "Pay What You Can Package ($500)",
            "purchased_at": "2018-12-01T17:56:40.769-08:00"
        },
        {
            "id": 1226,
            "first_name": "Scot",
            "last_name": "McGregor",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-02T09:17:41.000-08:00"
        },
        {
            "id": 1233,
            "first_name": "Michael",
            "last_name": "Alex",
            "purchased_quantity": 50,
            "dollar_price": 2500.0,
            "package_name": "The Late Show with Stephen Colbert",
            "purchased_at": "2018-12-02T17:30:29.462-08:00"
        },
        {
            "id": 1238,
            "first_name": "Raymond",
            "last_name": "Rogers",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-03T04:17:02.218-08:00"
        },
        {
            "id": 1247,
            "first_name": "Adam",
            "last_name": "Westbrook",
            "purchased_quantity": 50,
            "dollar_price": 2500.0,
            "package_name": "Hannity",
            "purchased_at": "2018-12-03T15:06:17.238-08:00"
        },
        {
            "id": 1258,
            "first_name": "Meg",
            "last_name": "Hopley",
            "purchased_quantity": 50,
            "dollar_price": 2500.0,
            "package_name": "Meet the Press",
            "purchased_at": "2018-12-04T13:33:06.556-08:00"
        },
        {
            "id": 1260,
            "first_name": "Diane",
            "last_name": "Ranieri",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-04T17:25:29.641-08:00"
        },
        {
            "id": 1264,
            "first_name": "Stephen",
            "last_name": "Buchanan",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-04T19:58:36.364-08:00"
        },
        {
            "id": 1265,
            "first_name": "Marc",
            "last_name": "Grasso",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-12-04T20:17:59.727-08:00"
        },
        {
            "id": 1267,
            "first_name": "Philip ",
            "last_name": "Canzano",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-04T20:39:27.580-08:00"
        },
        {
            "id": 1272,
            "first_name": "Bishop",
            "last_name": "Bader",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-05T15:22:42.762-08:00"
        },
        {
            "id": 1273,
            "first_name": "Nate",
            "last_name": "Clark",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-05T16:06:15.657-08:00"
        },
        {
            "id": 1277,
            "first_name": "William",
            "last_name": "Serletis",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-05T20:21:12.963-08:00"
        },
        {
            "id": 1279,
            "first_name": "Rick",
            "last_name": "Cangelosi",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-06T06:04:45.673-08:00"
        },
        {
            "id": 1283,
            "first_name": "Brad",
            "last_name": "Weiner",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-06T07:45:00.284-08:00"
        },
        {
            "id": 1285,
            "first_name": "Sean",
            "last_name": "Charette",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-06T10:10:10.546-08:00"
        },
        {
            "id": 1290,
            "first_name": "Parker",
            "last_name": "Chehak",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-06T12:43:34.992-08:00"
        },
        {
            "id": 1293,
            "first_name": "Casey",
            "last_name": "Winn",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-06T15:22:53.608-08:00"
        },
        {
            "id": 1295,
            "first_name": "Ronald",
            "last_name": "Schulz",
            "purchased_quantity": 20,
            "dollar_price": 1000.0,
            "package_name": "Susan Sarandon",
            "purchased_at": "2018-12-06T16:28:01.116-08:00"
        },
        {
            "id": 1296,
            "first_name": "Sharee ",
            "last_name": "Boneham",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-06T16:46:15.836-08:00"
        },
        {
            "id": 1297,
            "first_name": "Dennis",
            "last_name": "Rosen",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-06T17:42:32.569-08:00"
        },
        {
            "id": 1305,
            "first_name": "David",
            "last_name": "Rosado",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-07T06:27:54.697-08:00"
        },
        {
            "id": 1308,
            "first_name": "Hannah",
            "last_name": "Witt",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-07T07:56:41.376-08:00"
        },
        {
            "id": 1309,
            "first_name": "Douglas",
            "last_name": "Ferrarelli",
            "purchased_quantity": 10,
            "dollar_price": 500.0,
            "package_name": "Pay What You Can Package ($500)",
            "purchased_at": "2018-12-07T09:23:43.899-08:00"
        },
        {
            "id": 1311,
            "first_name": "Nikesh",
            "last_name": "Patel",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-07T11:18:29.425-08:00"
        },
        {
            "id": 1313,
            "first_name": "Alina",
            "last_name": "",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-07T11:35:13.171-08:00"
        },
        {
            "id": 1315,
            "first_name": "Josh",
            "last_name": "Diekmann",
            "purchased_quantity": 20,
            "dollar_price": 1000.0,
            "package_name": "Jim Carrey",
            "purchased_at": "2018-12-07T11:50:11.853-08:00"
        },
        {
            "id": 1318,
            "first_name": "Trine",
            "last_name": "Bergestuen",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-07T13:36:05.827-08:00"
        },
        {
            "id": 1320,
            "first_name": "Kellen",
            "last_name": "",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-07T15:09:38.347-08:00"
        },
        {
            "id": 1321,
            "first_name": "Justin",
            "last_name": null,
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-07T15:28:40.288-08:00"
        },
        {
            "id": 1322,
            "first_name": "Laine",
            "last_name": "Scheuble",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-07T15:29:52.046-08:00"
        },
        {
            "id": 1324,
            "first_name": "Scott",
            "last_name": "Stanton",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-07T15:33:54.953-08:00"
        },
        {
            "id": 1328,
            "first_name": "",
            "last_name": "",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-07T16:08:19.562-08:00"
        },
        {
            "id": 1329,
            "first_name": "John",
            "last_name": "Astaunda",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-07T16:21:15.318-08:00"
        },
        {
            "id": 1332,
            "first_name": "James",
            "last_name": "Simon",
            "purchased_quantity": 20,
            "dollar_price": 1000.0,
            "package_name": "Colin Kaepernick",
            "purchased_at": "2018-12-07T16:30:15.031-08:00"
        },
        {
            "id": 1333,
            "first_name": "James",
            "last_name": "Simon",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-07T16:32:31.544-08:00"
        },
        {
            "id": 1336,
            "first_name": "Kelly",
            "last_name": "Devers",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-07T20:10:03.327-08:00"
        },
        {
            "id": 1344,
            "first_name": "Alexander",
            "last_name": "Wolf",
            "purchased_quantity": 10,
            "dollar_price": 500.0,
            "package_name": "Pay What You Can Package ($500)",
            "purchased_at": "2018-12-09T06:31:17.147-08:00"
        },
        {
            "id": 1350,
            "first_name": "Tom",
            "last_name": "Carnesciali",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-09T14:14:33.498-08:00"
        },
        {
            "id": 1363,
            "first_name": "Kristina",
            "last_name": "Farris",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-10T19:20:44.076-08:00"
        },
        {
            "id": 1364,
            "first_name": "Justin",
            "last_name": "Fiorille",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-10T19:48:17.589-08:00"
        },
        {
            "id": 1366,
            "first_name": null,
            "last_name": null,
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-10T22:17:11.355-08:00"
        },
        {
            "id": 1367,
            "first_name": "Lucas",
            "last_name": "Dietz",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-11T07:42:39.888-08:00"
        },
        {
            "id": 1379,
            "first_name": "Raven",
            "last_name": "Ohlemacher",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-11T13:22:56.797-08:00"
        },
        {
            "id": 1382,
            "first_name": "Michele",
            "last_name": "Rollason",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-12-11T14:45:27.627-08:00"
        },
        {
            "id": 1383,
            "first_name": "Mat \"Hippie\"",
            "last_name": "Welch",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-11T15:10:39.148-08:00"
        },
        {
            "id": 1384,
            "first_name": "JuanO",
            "last_name": "",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-11T15:15:42.122-08:00"
        },
        {
            "id": 1390,
            "first_name": "Justin",
            "last_name": null,
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-11T16:37:47.983-08:00"
        },
        {
            "id": 1403,
            "first_name": "Zech",
            "last_name": "Raeber",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-11T21:09:58.764-08:00"
        },
        {
            "id": 1407,
            "first_name": "Jennifer",
            "last_name": "Nissley-Clark",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-12-12T07:49:02.379-08:00"
        },
        {
            "id": 1417,
            "first_name": "Peter",
            "last_name": "Hamby",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-12T15:55:39.541-08:00"
        },
        {
            "id": 1437,
            "first_name": "Josh",
            "last_name": "Diekmann",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-13T11:32:59.902-08:00"
        },
        {
            "id": 1438,
            "first_name": "MICHAEL",
            "last_name": "SCOTT",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-13T12:25:31.831-08:00"
        },
        {
            "id": 1450,
            "first_name": "Ethan",
            "last_name": "Silvers",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-13T15:48:05.457-08:00"
        },
        {
            "id": 1451,
            "first_name": "James",
            "last_name": "Simon",
            "purchased_quantity": 20,
            "dollar_price": 1000.0,
            "package_name": "Face the Nation",
            "purchased_at": "2018-12-13T15:59:33.258-08:00"
        },
        {
            "id": 1452,
            "first_name": "Donald",
            "last_name": "Necessary",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-12-13T16:00:16.885-08:00"
        },
        {
            "id": 1454,
            "first_name": "Steve",
            "last_name": "Barton",
            "purchased_quantity": 50,
            "dollar_price": 2500.0,
            "package_name": "Last Week Tonight",
            "purchased_at": "2018-12-13T16:26:39.241-08:00"
        },
        {
            "id": 1456,
            "first_name": "Stefan",
            "last_name": "Bern",
            "purchased_quantity": 10,
            "dollar_price": 500.0,
            "package_name": "Pay What You Can Package ($500)",
            "purchased_at": "2018-12-13T16:46:49.947-08:00"
        },
        {
            "id": 1459,
            "first_name": "Lisa",
            "last_name": "Kleinwort",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-12-13T17:56:46.526-08:00"
        },
        {
            "id": 1460,
            "first_name": "Josef",
            "last_name": "Miller",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-13T18:06:55.869-08:00"
        },
        {
            "id": 1461,
            "first_name": "Brian",
            "last_name": "Sonntag",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-13T18:32:40.470-08:00"
        },
        {
            "id": 1464,
            "first_name": "Nancy",
            "last_name": "Weaver",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-13T18:45:03.992-08:00"
        },
        {
            "id": 1465,
            "first_name": "James",
            "last_name": "Gustavson",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-12-13T18:50:34.046-08:00"
        },
        {
            "id": 1468,
            "first_name": "Toren",
            "last_name": "Apessos",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-13T19:01:38.143-08:00"
        },
        {
            "id": 1469,
            "first_name": "Rusty",
            "last_name": "Bias",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-13T19:03:57.309-08:00"
        },
        {
            "id": 1471,
            "first_name": "Michael",
            "last_name": "Mennenga",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-13T19:18:05.332-08:00"
        },
        {
            "id": 1472,
            "first_name": "Douglas",
            "last_name": "Reeves",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-13T19:22:37.394-08:00"
        },
        {
            "id": 1476,
            "first_name": "Trans-girls are magic",
            "last_name": "Jade Hess",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-13T20:48:25.230-08:00"
        },
        {
            "id": 1477,
            "first_name": "Hayden",
            "last_name": "Prescott",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-12-13T20:48:42.163-08:00"
        },
        {
            "id": 1484,
            "first_name": "Paul",
            "last_name": "Lancaster",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-12-14T01:37:39.406-08:00"
        },
        {
            "id": 1489,
            "first_name": "Tree",
            "last_name": "G",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-14T08:12:33.594-08:00"
        },
        {
            "id": 1491,
            "first_name": "James",
            "last_name": "",
            "purchased_quantity": 10,
            "dollar_price": 500.0,
            "package_name": "Pay What You Can Package ($500)",
            "purchased_at": "2018-12-14T08:49:09.798-08:00"
        },
        {
            "id": 1495,
            "first_name": "Jericho",
            "last_name": "Anderson",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-14T12:52:19.075-08:00"
        },
        {
            "id": 1498,
            "first_name": "John",
            "last_name": "Painter",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-14T14:16:38.822-08:00"
        },
        {
            "id": 1505,
            "first_name": "Tom",
            "last_name": "Grosman",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-14T15:08:15.060-08:00"
        },
        {
            "id": 1506,
            "first_name": "James ",
            "last_name": "Abell",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-14T15:10:24.285-08:00"
        },
        {
            "id": 1507,
            "first_name": "Devin",
            "last_name": "Jorgenson",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-14T15:22:19.714-08:00"
        },
        {
            "id": 1508,
            "first_name": "Bethany",
            "last_name": "Latham",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-14T15:31:14.759-08:00"
        },
        {
            "id": 1512,
            "first_name": "René",
            "last_name": "Jensen",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-14T15:58:37.709-08:00"
        },
        {
            "id": 1513,
            "first_name": "Bill",
            "last_name": "Pepper",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-14T16:03:31.440-08:00"
        },
        {
            "id": 1514,
            "first_name": "Christopher",
            "last_name": "Morrow",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-14T16:11:53.028-08:00"
        },
        {
            "id": 1516,
            "first_name": "Jeff",
            "last_name": "Manzer",
            "purchased_quantity": 10,
            "dollar_price": 500.0,
            "package_name": "Pay What You Can Package ($500)",
            "purchased_at": "2018-12-14T16:21:03.377-08:00"
        },
        {
            "id": 1517,
            "first_name": "Trevor",
            "last_name": "Campbell",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-14T16:32:05.086-08:00"
        },
        {
            "id": 1518,
            "first_name": "Gabriel",
            "last_name": "Gray",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-14T16:46:05.791-08:00"
        },
        {
            "id": 1522,
            "first_name": "John",
            "last_name": "Welch",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-14T20:09:41.492-08:00"
        },
        {
            "id": 1525,
            "first_name": "Fernando",
            "last_name": "Fernald",
            "purchased_quantity": 10,
            "dollar_price": 500.0,
            "package_name": "Pay What You Can Package ($500)",
            "purchased_at": "2018-12-14T21:45:17.980-08:00"
        },
        {
            "id": 1550,
            "first_name": "Gary",
            "last_name": "Breaux",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-12-15T15:20:16.800-08:00"
        },
        {
            "id": 1551,
            "first_name": "Gary",
            "last_name": "Breaux",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-12-15T15:22:00.197-08:00"
        },
        {
            "id": 1557,
            "first_name": "Jim R.",
            "last_name": "Marentes",
            "purchased_quantity": 10,
            "dollar_price": 500.0,
            "package_name": "Pay What You Can Package ($500)",
            "purchased_at": "2018-12-15T21:32:49.283-08:00"
        },
        {
            "id": 1558,
            "first_name": "Ahmad",
            "last_name": "Ali",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-15T22:46:59.950-08:00"
        },
        {
            "id": 1569,
            "first_name": "Robert",
            "last_name": "May",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-16T18:17:23.553-08:00"
        },
        {
            "id": 1573,
            "first_name": "Graham",
            "last_name": "Watson",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-12-16T20:19:06.315-08:00"
        },
        {
            "id": 1575,
            "first_name": "Justin",
            "last_name": "Hoffman",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-16T21:45:10.791-08:00"
        },
        {
            "id": 1576,
            "first_name": "Sarah",
            "last_name": "Gray",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-16T23:46:37.517-08:00"
        },
        {
            "id": 1579,
            "first_name": "Bill",
            "last_name": "Ormerod     (pronounced omer od)",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-17T04:50:32.165-08:00"
        },
        {
            "id": 1602,
            "first_name": "Sam",
            "last_name": "waddington",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-17T15:03:49.151-08:00"
        },
        {
            "id": 1603,
            "first_name": "Paul",
            "last_name": "",
            "purchased_quantity": 10,
            "dollar_price": 500.0,
            "package_name": "Dan Carlin's Hardcore History",
            "purchased_at": "2018-12-17T15:05:56.449-08:00"
        },
        {
            "id": 1604,
            "first_name": "Trevor",
            "last_name": "Campbell",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-12-17T15:09:41.956-08:00"
        },
        {
            "id": 1606,
            "first_name": "JR",
            "last_name": "McLaughlin",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-17T15:36:46.572-08:00"
        },
        {
            "id": 1607,
            "first_name": "Joe",
            "last_name": "Koss",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-17T15:37:09.645-08:00"
        },
        {
            "id": 1609,
            "first_name": "Stefani",
            "last_name": "Giacopazzi",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-17T15:41:46.896-08:00"
        },
        {
            "id": 1616,
            "first_name": "Brian",
            "last_name": "Wagner",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-17T16:45:59.787-08:00"
        },
        {
            "id": 1618,
            "first_name": "Alan",
            "last_name": "Moser",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-17T18:25:53.322-08:00"
        },
        {
            "id": 1626,
            "first_name": "TJ",
            "last_name": "McGill",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-17T18:37:24.225-08:00"
        },
        {
            "id": 1643,
            "first_name": "Amanda",
            "last_name": "Becker",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-18T05:58:00.222-08:00"
        },
        {
            "id": 1646,
            "first_name": "Melissa",
            "last_name": null,
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-18T07:06:39.751-08:00"
        },
        {
            "id": 1655,
            "first_name": "ronald",
            "last_name": "joseph",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-18T08:05:12.761-08:00"
        },
        {
            "id": 1673,
            "first_name": "Maryalice ",
            "last_name": "Coleman",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-12-18T15:06:00.495-08:00"
        },
        {
            "id": 1674,
            "first_name": "Katelyn ",
            "last_name": "Souza",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-12-18T15:06:16.854-08:00"
        },
        {
            "id": 1702,
            "first_name": "Jack",
            "last_name": "Sherman",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-19T07:05:57.220-08:00"
        },
        {
            "id": 1718,
            "first_name": "Tyrrell",
            "last_name": "Woolbert",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-12-19T16:56:01.574-08:00"
        },
        {
            "id": 1727,
            "first_name": "Jenna",
            "last_name": "MacInnis",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-19T18:59:25.768-08:00"
        },
        {
            "id": 1732,
            "first_name": "Mike",
            "last_name": "Russo",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-12-19T19:39:19.467-08:00"
        },
        {
            "id": 1760,
            "first_name": "Beck",
            "last_name": "Carman",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-20T10:47:25.238-08:00"
        },
        {
            "id": 1774,
            "first_name": "Danneca",
            "last_name": "Mundle",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-20T13:36:47.372-08:00"
        },
        {
            "id": 1797,
            "first_name": "John",
            "last_name": "Grein",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-20T18:40:08.383-08:00"
        },
        {
            "id": 1806,
            "first_name": "Frederick",
            "last_name": "Ott",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-21T01:35:25.979-08:00"
        },
        {
            "id": 1835,
            "first_name": "Dave",
            "last_name": "Ketchum",
            "purchased_quantity": 10,
            "dollar_price": 500.0,
            "package_name": "Pay What You Can Package ($500)",
            "purchased_at": "2018-12-21T12:57:20.056-08:00"
        },
        {
            "id": 1843,
            "first_name": "Katrina",
            "last_name": "G",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-21T14:51:56.143-08:00"
        },
        {
            "id": 1845,
            "first_name": "Parker",
            "last_name": "Adelson",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-21T15:03:47.004-08:00"
        },
        {
            "id": 1846,
            "first_name": "Shawn",
            "last_name": "Baird",
            "purchased_quantity": 20,
            "dollar_price": 1000.0,
            "package_name": "Progressive Change Campaign Committee",
            "purchased_at": "2018-12-21T15:08:01.522-08:00"
        },
        {
            "id": 1858,
            "first_name": "Mr. M.T. (Martijn)",
            "last_name": "de Meulmeester",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-21T19:08:41.574-08:00"
        },
        {
            "id": 1879,
            "first_name": "Candace",
            "last_name": "Weiss",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-22T08:20:54.683-08:00"
        },
        {
            "id": 1891,
            "first_name": "Sarah Jean",
            "last_name": "Kutzler",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-22T10:00:43.433-08:00"
        },
        {
            "id": 1899,
            "first_name": "Evan",
            "last_name": "Vredenburgh",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-22T12:37:52.804-08:00"
        },
        {
            "id": 1929,
            "first_name": "MARK",
            "last_name": "GARCIA",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-23T04:31:22.151-08:00"
        },
        {
            "id": 1930,
            "first_name": "Alexis",
            "last_name": "Haas",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-23T04:51:40.629-08:00"
        },
        {
            "id": 1979,
            "first_name": "Joan T",
            "last_name": "Masters",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-23T19:09:03.401-08:00"
        },
        {
            "id": 2017,
            "first_name": "Kimberly",
            "last_name": "Spikes",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-24T10:08:58.135-08:00"
        },
        {
            "id": 2109,
            "first_name": "Sam",
            "last_name": "Z",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-25T07:29:30.269-08:00"
        },
        {
            "id": 2113,
            "first_name": "Devin ",
            "last_name": "Mason",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-12-25T07:53:53.577-08:00"
        },
        {
            "id": 2194,
            "first_name": "Jason",
            "last_name": "Huggett",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-26T08:11:25.646-08:00"
        },
        {
            "id": 2195,
            "first_name": "Larry",
            "last_name": "Pimentel",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-26T08:13:55.474-08:00"
        },
        {
            "id": 2218,
            "first_name": "Jim ",
            "last_name": "Varner ",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-26T16:01:09.147-08:00"
        },
        {
            "id": 2221,
            "first_name": "Joseph",
            "last_name": "Pisano",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-26T16:53:40.929-08:00"
        },
        {
            "id": 2225,
            "first_name": "Steve",
            "last_name": "Dillon",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-26T17:54:50.423-08:00"
        },
        {
            "id": 2249,
            "first_name": "Moni",
            "last_name": "Andraska",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-27T09:58:06.696-08:00"
        },
        {
            "id": 2251,
            "first_name": "Patrick ",
            "last_name": "Michael",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-27T10:29:54.875-08:00"
        },
        {
            "id": 2255,
            "first_name": "Abdullatef",
            "last_name": "Al-Zamel",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-12-27T14:13:12.522-08:00"
        },
        {
            "id": 2259,
            "first_name": "Josh",
            "last_name": "Berndt",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-27T15:24:00.572-08:00"
        },
        {
            "id": 2265,
            "first_name": "peter",
            "last_name": "Colon",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-27T16:39:44.363-08:00"
        },
        {
            "id": 2273,
            "first_name": "Joan T",
            "last_name": "Masters",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-27T17:36:22.560-08:00"
        },
        {
            "id": 2278,
            "first_name": "michele",
            "last_name": "mcconnell",
            "purchased_quantity": 10,
            "dollar_price": 500.0,
            "package_name": "Pay What You Can Package ($500)",
            "purchased_at": "2018-12-27T21:06:07.319-08:00"
        },
        {
            "id": 2281,
            "first_name": "Isaiah",
            "last_name": "Bell",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-28T02:13:11.060-08:00"
        },
        {
            "id": 2282,
            "first_name": "Mike",
            "last_name": "Smith",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-28T03:25:01.722-08:00"
        },
        {
            "id": 2286,
            "first_name": "Ryan",
            "last_name": "Leblanc",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-28T08:11:37.033-08:00"
        },
        {
            "id": 2296,
            "first_name": "Mick",
            "last_name": "Landholm",
            "purchased_quantity": 10,
            "dollar_price": 500.0,
            "package_name": "Pay What You Can Package ($500)",
            "purchased_at": "2018-12-28T13:13:12.670-08:00"
        },
        {
            "id": 2300,
            "first_name": "Matthew",
            "last_name": "Bentivegna",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-28T13:57:39.415-08:00"
        },
        {
            "id": 2302,
            "first_name": "Aaron",
            "last_name": "Burleson",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-28T15:06:00.834-08:00"
        },
        {
            "id": 2303,
            "first_name": "Michael",
            "last_name": "Huff",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-28T15:08:44.731-08:00"
        },
        {
            "id": 2305,
            "first_name": "Katy",
            "last_name": "Evans",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-28T15:11:58.616-08:00"
        },
        {
            "id": 2307,
            "first_name": "Kirk",
            "last_name": "Tailor",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-28T15:36:22.059-08:00"
        },
        {
            "id": 2310,
            "first_name": "Naedrie",
            "last_name": "Bonucchi",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-28T16:04:11.943-08:00"
        },
        {
            "id": 2312,
            "first_name": "Stefan",
            "last_name": "Bern",
            "purchased_quantity": 20,
            "dollar_price": 1000.0,
            "package_name": "MoveOn",
            "purchased_at": "2018-12-28T16:40:29.190-08:00"
        },
        {
            "id": 2327,
            "first_name": "HotKarlMarx",
            "last_name": "",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-29T09:42:31.079-08:00"
        },
        {
            "id": 2330,
            "first_name": "Logan",
            "last_name": "Gardner",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-29T10:47:05.347-08:00"
        },
        {
            "id": 2334,
            "first_name": "Esther",
            "last_name": "Davies Venn",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-29T12:24:19.089-08:00"
        },
        {
            "id": 2336,
            "first_name": "Robert",
            "last_name": "Funk",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-29T13:03:02.412-08:00"
        },
        {
            "id": 2342,
            "first_name": "Sandra",
            "last_name": "Balduf Miller",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-29T16:01:36.461-08:00"
        },
        {
            "id": 2348,
            "first_name": "Mya",
            "last_name": "Kraft",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-29T19:00:39.975-08:00"
        },
        {
            "id": 2357,
            "first_name": "Andrea",
            "last_name": "Curtis",
            "purchased_quantity": 10,
            "dollar_price": 500.0,
            "package_name": "Pay What You Can Package ($500)",
            "purchased_at": "2018-12-30T12:52:55.077-08:00"
        },
        {
            "id": 2360,
            "first_name": "Steve",
            "last_name": "Pahl",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-30T14:51:36.129-08:00"
        },
        {
            "id": 2364,
            "first_name": "Jo",
            "last_name": "Peterson",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-30T16:10:59.843-08:00"
        },
        {
            "id": 2371,
            "first_name": "Michael",
            "last_name": "Fors",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-30T22:17:28.895-08:00"
        },
        {
            "id": 2374,
            "first_name": "Jeff",
            "last_name": "Manzer",
            "purchased_quantity": 20,
            "dollar_price": 1000.0,
            "package_name": "Shepard Smith Reporting",
            "purchased_at": "2018-12-31T00:57:43.752-08:00"
        },
        {
            "id": 2379,
            "first_name": "Jon",
            "last_name": "McClain",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-31T10:40:22.317-08:00"
        },
        {
            "id": 2386,
            "first_name": "Chriss",
            "last_name": "Grimble",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-31T14:57:43.202-08:00"
        },
        {
            "id": 2387,
            "first_name": "Amber",
            "last_name": "Cart",
            "purchased_quantity": 10,
            "dollar_price": 500.0,
            "package_name": "Pay What You Can Package ($500)",
            "purchased_at": "2018-12-31T14:59:47.409-08:00"
        },
        {
            "id": 2391,
            "first_name": "Ennis",
            "last_name": "Smith",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-31T15:31:23.493-08:00"
        },
        {
            "id": 2392,
            "first_name": "Julie",
            "last_name": "Gordon",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-31T15:32:39.764-08:00"
        },
        {
            "id": 2393,
            "first_name": "James",
            "last_name": "McMillan",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-31T15:35:22.968-08:00"
        },
        {
            "id": 2394,
            "first_name": "Gregory",
            "last_name": "Matyola",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-31T15:35:49.167-08:00"
        },
        {
            "id": 2399,
            "first_name": "Brandon",
            "last_name": "Stotts",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-31T15:59:25.460-08:00"
        },
        {
            "id": 2400,
            "first_name": "",
            "last_name": "",
            "purchased_quantity": 10,
            "dollar_price": 500.0,
            "package_name": "Pay What You Can Package ($500)",
            "purchased_at": "2018-12-31T16:06:09.999-08:00"
        },
        {
            "id": 2402,
            "first_name": "Anne",
            "last_name": "McGuane",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-31T16:16:51.130-08:00"
        },
        {
            "id": 2403,
            "first_name": "Nahide",
            "last_name": "Gulensoy",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-31T16:19:05.911-08:00"
        },
        {
            "id": 2404,
            "first_name": "Neal",
            "last_name": "Clark",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-31T16:19:33.976-08:00"
        },
        {
            "id": 2406,
            "first_name": "Becky",
            "last_name": "Shampay",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-12-31T16:40:38.407-08:00"
        },
        {
            "id": 2411,
            "first_name": "Mark",
            "last_name": "Hensman",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-31T17:04:35.922-08:00"
        },
        {
            "id": 2412,
            "first_name": "Raz",
            "last_name": null,
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2018-12-31T17:11:05.320-08:00"
        },
        {
            "id": 2421,
            "first_name": "TIMOTHY",
            "last_name": "JORDAN",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-31T17:35:40.174-08:00"
        },
        {
            "id": 2422,
            "first_name": "gary",
            "last_name": "steelman",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-31T17:39:30.353-08:00"
        },
        {
            "id": 2428,
            "first_name": "Jeffrey",
            "last_name": "Williams",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2018-12-31T20:02:43.712-08:00"
        },
        {
            "id": 2435,
            "first_name": "Dennis Criaig",
            "last_name": "Roof",
            "purchased_quantity": 10,
            "dollar_price": 500.0,
            "package_name": "Pay What You Can Package ($500)",
            "purchased_at": "2018-12-31T21:50:17.003-08:00"
        },
        {
            "id": 2440,
            "first_name": "Taylor",
            "last_name": "Shamshiri",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2019-01-01T11:53:43.071-08:00"
        },
        {
            "id": 2445,
            "first_name": "Owais",
            "last_name": "Baig",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2019-01-01T20:31:35.968-08:00"
        },
        {
            "id": 2447,
            "first_name": "Sid",
            "last_name": null,
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2019-01-02T09:22:36.015-08:00"
        },
        {
            "id": 2512,
            "first_name": "Simon",
            "last_name": "Brick",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2019-01-13T12:33:59.002-08:00"
        },
        {
            "id": 2514,
            "first_name": "Jordan",
            "last_name": "Wruck",
            "purchased_quantity": 1,
            "dollar_price": 50.0,
            "package_name": "Pay What You Can Package ($50)",
            "purchased_at": "2019-01-14T15:08:49.222-08:00"
        },
        {
            "id": 2521,
            "first_name": "Brandi",
            "last_name": "Haskins",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2019-01-17T00:54:05.374-08:00"
        },
        {
            "id": 2542,
            "first_name": "Chriss",
            "last_name": "Grimble",
            "purchased_quantity": 3,
            "dollar_price": 150.0,
            "package_name": "Pay What You Can Package ($150)",
            "purchased_at": "2019-01-21T16:55:34.867-08:00"
        },
        {
            "id": 2556,
            "first_name": "Karla",
            "last_name": "Rossi",
            "purchased_quantity": 10,
            "dollar_price": 500.0,
            "package_name": "Pay What You Can Package ($500)",
            "purchased_at": "2019-01-24T14:06:55.098-08:00"
        }
    ];
}